import { createFeatureSelector } from '@ngrx/store';
import { createSelector } from 'reselect';
import { getDatasetResultByQueryToken } from '../dataset-result/dataset-result.selectors';
import { makeViewFromResultsAndAttrsFeature } from '../switch-resource-helpers';
import { Switch } from '@mode/shared/util-switch';
import * as fromSwitchAttrs from './switch-attrs.reducer';
import { Attr } from '@mode-switch/model';

export const selectSwitchAttrsState = createFeatureSelector<fromSwitchAttrs.SwitchAttrsFeatureState>(
  fromSwitchAttrs.switchAttrsFeatureKey
);

export const selectAttrs = createSelector(selectSwitchAttrsState, (feature) => feature?.attrs);

export const getSwitchAttrsTokens = createSelector(selectAttrs, fromSwitchAttrs.selectAttrsTokens);

export const getSwitchAttrsFeatureEntities = createSelector(selectAttrs, fromSwitchAttrs.selectAttrsEntities);

export const getSwitchAttrsFeatureByToken = (token: string) =>
  createSelector(getSwitchAttrsFeatureEntities, (entities) => entities[token]);

export const getLocalSwitchViewAttrFeatures = (token: string) =>
  createSelector(
    getSwitchAttrsFeatureByToken(token),
    (attrs) => attrs?.switchAttrsData.filter((attr) => attr.isLocal) || []
  );

export const getSwitchViewAttrHasCalc = (token: string) =>
  createSelector(
    getSwitchAttrsFeatureByToken(token),
    (attrs) => !!attrs?.switchAttrsData.some((attr) => attr.source === Attr.Source.Calc)
  );

export const createColumnsAndAttrsSwitchModelByQueryToken = (queryToken: string, switchViewToken: string) =>
  createSelector(
    getDatasetResultByQueryToken(queryToken),
    getSwitchAttrsFeatureByToken(switchViewToken),
    (datasetResult, switchAttrs) => {
      if (datasetResult && switchAttrs) {
        const view = makeViewFromResultsAndAttrsFeature(datasetResult, switchAttrs.switchAttrsData);
        return Switch.Models.makeFromView(view.name, view);
      }

      return;
    }
  );
